import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { KnowledgePanelService } from '@modules/knowledge/services/knowledge-panel.service';
import { type SelectedMarker } from '@modules/knowledge/types/selected-marker';

/**
 * The knowledge panel's Selected row, rendered from its selection store — in the Dynamic Panel that
 * includes the selection mirrored from the 3rd panel — and its keywords.
 * See devdoc/specs/knowledge-panel-selection-scopes.md.
 */
@Component({
  selector: 'app-filters-panel',
  templateUrl: './filters-panel.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FiltersPanelComponent {
  private readonly kpService = inject(KnowledgePanelService);

  protected readonly markers = toSignal(this.kpService.getSelectedMarkers(), { requireSync: true });

  protected remove(marker: SelectedMarker): void {
    this.kpService.removeSelectedMarker(marker);
  }

  protected keepUpTo(event: MouseEvent, marker: SelectedMarker): void {
    event.stopPropagation();
    event.preventDefault();

    this.kpService.keepSelectedMarkersUpTo(marker);
  }

  protected clear(): void {
    this.kpService.clearSelection();
  }
}
